function loadClientInfo() {

  var x = fetch('dataImport/GetClientInfo', {
    method: 'GET'
  })
    .then(x => x.json()).catch((error) => { x = null })

  return x;
}

export { loadClientInfo }

